// import * as Sentry from '@sentry/react';
import { isAxiosError as _isAxiosError, isCancel } from 'axios';
import type { AxiosError } from 'axios';

import {
  BaseApiError,
  NetworkApiError,
  Server500ApiError,
  Unauthorized401ApiError,
  UnknownApiError,
  OperationAbortedError,
  Validation400ApiErrorWithCause,
  NotFoundApiError,
} from 'src/errors';

export function isAxiosError(e: unknown): e is AxiosError<unknown> {
  return _isAxiosError(e);
}

export function throwApiError(e: unknown): never {
  if (e instanceof BaseApiError) {
    throw e;
  }

  if (isCancel(e)) {
    throw new OperationAbortedError(e.message ?? '');
  }

  if (isAxiosError(e)) {
    if (!e.response) {
      throw new NetworkApiError(e);
    }

    if (e.response.status >= 500) {
      throw new Server500ApiError(e);
    }

    if (e.response.status === 401) {
      throw new Unauthorized401ApiError(e);
    }

    if (e.response.status === 400) {
      const messageRaw = (() => {
        if (typeof e.response?.data === 'object' && e.response.data !== null && 'message' in e.response.data) {
          return e.response.data.message;
        }

        return null;
      })();

      let parsedMessage = undefined;

      if (Array.isArray(messageRaw)) {
        if (typeof messageRaw[0] === 'string') {
          parsedMessage = messageRaw[0];
        }
      }
      if (typeof messageRaw === 'string') {
        parsedMessage = messageRaw;
      }
      throw new Validation400ApiErrorWithCause<unknown>(e, e.response.data, parsedMessage);
    }

    if (e.response.status === 404) {
      throw new NotFoundApiError(e);
    }

    throw new UnknownApiError(e);
  }

  throw e;
}
